<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/05_Preface"><em class="italic">Preface</em></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Abbreviations"><em class="italic">Abbreviations</em></a></h2>
<h2 class="toct"><a href="#/xhtml/08_Chapter01">Sir Stanley Goodall</a></h2>
<h2 class="toc"><a href="#/xhtml/09_Chapter02">The Royal Corps of Naval Constructors</a></h2>
<h2 class="toc"><a href="#/xhtml/10_Chapter03">Procurement and Output</a></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">Controller’s Department</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">Senior Admiralty Officials 1939–1945</span></h2>
<h2 class="toct"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">The Diaries 1939–1945</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample">1939</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample">1940</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample">1941</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample">1942</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample">1943</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample">1944</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter13" title="Link target outside of Sample">1945</span></h2>
<h2 class="toct"><span href="#/xhtml/21_Sources" title="Link target outside of Sample"><em class="italic">Sources</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?56010b56